import React, { useState } from "react";
import { useAuth } from "../contex/AuthContext";

export default function VerifyEmailScreen() {
  const { user, logout, resendVerification, refreshUser } = useAuth();
  const [sent, setSent] = useState(false);
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState("");

  const handleResend = async () => {
    try {
      await resendVerification();
      setSent(true);
      setError("");
    } catch (err) {
      setError("Failed to send email. Please try again.");
    }
  };

  const handleCheckVerification = async () => {
    setChecking(true);
    setError("");
    try {
      await refreshUser();
      if (!user?.emailVerified) {
        setError("Email not verified yet. Please check your inbox and click the link.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    }
    setChecking(false);
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.icon}>📧</div>
      <div style={styles.title}>Verify your email</div>
      <div style={styles.sub}>
        We sent a verification link to:
      </div>
      <div style={styles.email}>{user?.email}</div>
      <div style={styles.desc}>
        Click the link in your email to activate your account. Check your spam folder if you don't see it.
      </div>

      <button style={styles.primaryBtn} onClick={handleCheckVerification} disabled={checking}>
        {checking ? "Checking..." : "I've verified my email ✓"}
      </button>

      {error && <div style={styles.error}>{error}</div>}

      <div style={styles.divider}>
        <span style={styles.dividerText}>Didn't receive it?</span>
      </div>

      {sent ? (
        <div style={styles.successMsg}>✅ Verification email sent! Check your inbox.</div>
      ) : (
        <button style={styles.secondaryBtn} onClick={handleResend}>
          Resend verification email
        </button>
      )}

      <button style={styles.logoutBtn} onClick={logout}>
        Sign out and use a different account
      </button>
    </div>
  );
}

const styles = {
  wrap:         { minHeight:"100vh", background:"#0F0F13", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"32px 24px", textAlign:"center" },
  icon:         { fontSize:"56px", marginBottom:"20px" },
  title:        { fontSize:"26px", fontWeight:700, color:"#F0EFE8", letterSpacing:"-.5px", marginBottom:"10px" },
  sub:          { fontSize:"14px", color:"#9998A0", marginBottom:"6px" },
  email:        { fontSize:"15px", fontWeight:600, color:"#7C6EF8", marginBottom:"16px" },
  desc:         { fontSize:"13px", color:"#9998A0", lineHeight:1.6, marginBottom:"28px", maxWidth:"320px" },
  primaryBtn:   { width:"100%", maxWidth:"360px", padding:"15px", background:"#7C6EF8", border:"none", borderRadius:"12px", fontFamily:"inherit", fontSize:"15px", fontWeight:600, color:"#fff", cursor:"pointer", marginBottom:"16px", transition:"opacity .15s" },
  error:        { fontSize:"13px", color:"#F05D5D", marginBottom:"16px", maxWidth:"320px" },
  divider:      { width:"100%", maxWidth:"360px", display:"flex", alignItems:"center", gap:"12px", marginBottom:"16px" },
  dividerText:  { fontSize:"13px", color:"#5C5B63", whiteSpace:"nowrap" },
  successMsg:   { fontSize:"13px", color:"#2ECC8A", marginBottom:"16px", fontWeight:500 },
  secondaryBtn: { width:"100%", maxWidth:"360px", padding:"13px", background:"transparent", border:"1px solid rgba(255,255,255,0.13)", borderRadius:"12px", fontFamily:"inherit", fontSize:"14px", fontWeight:500, color:"#F0EFE8", cursor:"pointer", marginBottom:"16px" },
  logoutBtn:    { background:"none", border:"none", fontFamily:"inherit", fontSize:"13px", color:"#5C5B63", cursor:"pointer", marginTop:"8px", textDecoration:"underline" },
};